// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Chart } from "@components";
import type { AbsenceRateReportData } from "@modules/reporting/reducer/trends/absence-rate/types";

type OwnProps = $Exact<{
  reportData: AbsenceRateReportData,
  weeklyPeriod: boolean,
  reportDetails: Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const TrendAbsenceRateChart = ({ reportData, t, weeklyPeriod, reportDetails }: Props) => {
  const options = weeklyPeriod
    ? {
        xAxis: {
          labelRotation: 300,
        },
      }
    : {};
  const trendType = ((reportDetails || {}).filters || {}).trendType || "";

  return (
    <Chart
      type="ColumnChart"
      title={t("TRENDS_ABSENCE_RATE_HEADLINES_LABEL", {
        type: t(trendType),
      })}
      values={[
        [
          t("TYPE"),
          t(trendType),
          {
            role: "annotation",
          },
        ],
        ...((reportData.headlines || {}).periods || []).map(item => [
          item.description || item.key,
          item.value,
          t(trendType) === t("WORKING_HOURS_ABSENCE_RATE") ? `${item.value}%` : item.value,
        ]),
      ]}
      chartHeight={400}
      options={{
        legend: {
          position: "none",
        },
        vAxis: {
          minValue: 0,
          format: t(trendType) === t("WORKING_HOURS_ABSENCE_RATE") ? "#.#'%'" : null,
        },
        annotations: {
          format: t(trendType) === t("WORKING_HOURS_ABSENCE_RATE") ? "#%" : null,
          alwaysOutside: true,
          highContrast: false,
        },
      }}
    />
  );
};

export default localize()(TrendAbsenceRateChart);
